import React, {useState} from 'react';
import Video from '../../../../assest/homestay/v1.mp4'
import Video2 from '../../../../assest/homestay/v2.mp4'
import Image1 from '../../../../assest/homestay/9.jpeg'
import Image2 from '../../../../assest/homestay/29.jpeg'
import './housedetails2walkthrough.scss'

const HouseDetails2WalkThrough = () => {
	
	const [play, setPlay] = useState (false);
	const [playtwo, setPlayTwo] = useState (false);
	
	return (
		<div className="HouseDetails2WalkThrough-video-walkthrough">
			<h2>Explore the Stay</h2>
			
			<div className="main-HouseDetails2WalkThrough">
				<div className="HouseDetails2WalkThrough-video-container">
					{play ? (
						// <video src={Video} autoPlay controls />
						<iframe
							className="HouseDetails2WalkThrough-video-frame"
							src={Video}
							title="Video"
							style={{border: "none"}}
							allowFullScreen={true}
						/>
					) : (
						<>
							<img
								src={Image1}
								alt="video"
							/>
							
							<div className="HouseDetails2WalkThrough-video-play-overlay" onClick={() => setPlay (true)}>
								<button className="HouseDetails2WalkThrough-play-btn">▶</button>
								<span>Watch Stay Tour</span>
							</div>
						</>
					)}
				</div>
				<div className="HouseDetails2WalkThrough-video-container">
					
					{playtwo ? (
						// <video src={Video} autoPlay controls />
						<iframe
							className="HouseDetails2WalkThrough-video-frame"
							src={Video2}
							title="Video"
							style={{border: "none"}}
							allowFullScreen={true}
						/>
					) : (
						<>
							<img
								src={Image2}
								alt="video"
							/>
							
							<div className="HouseDetails2WalkThrough-video-play-overlay" onClick={() => setPlayTwo (true)}>
								<button className="HouseDetails2WalkThrough-play-btn">▶</button>
								<span>Watch Stay Tour</span>
							</div>
						</>
					)}
				
				</div>
			</div>
		</div>
	);
};

export default HouseDetails2WalkThrough;